<script>
    import {Listeners} from "../../../constants/listeners";

    export default {
        props: {
            rowData: {
                type: Object,
                required: true
            },
            rowIndex: {
                type: Number
            }
        },
        methods: {
            deleteItem (rowData) {
                this.$emitter.emit(Listeners.KS_DELETE_REPORT, rowData);
            },
            changeOwner (rowData) {
                this.$emitter.emit(Listeners.KS_CHANGE_OWNER_REPORT, rowData);
            },
        },
        computed: {
            canDelete(){
                return this.rowData.state === 10 || this.rowData.state === 2;
            },
            canChangeOwner(){
                return this.rowData.canChangeOwner;
            },
        },

    }
</script>
<template>
    <div class="custom-actions">
        <a href @click.prevent="deleteItem(rowData)" :title="$t('lang.group_report.delete_report_name', [rowData.name])" v-if="canDelete"><i class="fa fa-trash-o ks-icons" aria-hidden="true"></i></a>
        <a href @click.prevent="changeOwner(rowData)" :title="$t('lang.group_report.change_owner_report_name', [rowData.name])" v-if="canChangeOwner"><i class="fa fa-user-circle-o ks-icons" aria-hidden="true"></i></a>
    </div>
</template>
<style>


</style>
